import React from 'react';
import * as R from 'ramda';
import {useTranslation} from 'react-i18next';

import {PlanHolding} from '@/b2c/PlanDetail/Detail/PlanHolding';
import Portfolio from '@/b2c/PlanDetail/Detail/InvestmentLinkDetail/Portfolio';
import {BreakDownChartList} from '@/b2c/PlanDetail/Detail/BreakDownChart';

const showMetisDisclaimer = R.allPass([
  R.propEq('productCategory', 'TU'),
  R.compose(
    R.reject,
    R.propEq('portfolioType', '-')
  ),
]);

const MetisDisclaimerSection = ({companyName}) => {
  const {t: tr} = useTranslation('statements');

  return (
    <section className='note'>
      <p className='desc'>{tr('metis_disclaimer_2')}</p>
      <p className='desc'>{tr('metis_disclaimer_3')}</p>
      <p className='desc'>{tr('metis_disclaimer_4', {companyName})}</p>
    </section>
  );
};

const InvestmentLinkDetail = ({plan}) => (
  <>
    <PlanHolding plan={plan} />
    <BreakDownChartList type='allocation' data={plan.allocation} />
    {R.ifElse(
      showMetisDisclaimer,
      () => (
        <MetisDisclaimerSection
          companyName={R.propOr('', 'companyName', plan)}
        />
      ),
      () => <Portfolio currentPlan={plan} />
    )(plan)}
  </>
);
export default InvestmentLinkDetail;
